export default __webpack_public_path__ + "static/media/pictogramTransfer64.6df94a18.svg";